<template>
  <section id="contact" class="contact section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title animate-slide-up">
          {{ $t('contact.title') }}
        </h2>
        <p class="section-subtitle animate-slide-up">
          Pronto para transformar suas ideias em realidade? Vamos conversar sobre seu próximo projeto.
        </p>
      </div>
      
      <div class="contact-content">
        <div class="contact-info animate-slide-up">
          <div class="info-card card">
            <div class="info-header">
              <div class="info-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
              </div>
              <h3>{{ $t('contact.email') }}</h3>
            </div>
            <p><a href="mailto:contato@z3c.com.br">contato@z3c.com.br</a></p>
          </div>
          
          <div class="info-card card">
            <div class="info-header">
              <div class="info-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
              </div>
              <h3>{{ $t('contact.phone') }}</h3>
            </div>
            <p><a href="tel:+5551993402833">(51) 99340-2833</a></p>
          </div>
          
          <div class="info-card card">
            <div class="info-header">
              <div class="info-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3>{{ $t('contact.schedule') }}</h3>
            </div>
            <p>{{ $t('contact.scheduleText') }}</p>
            <p>{{ $t('contact.scheduleTime') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// Script removido - não há mais funcionalidade de contagem regressiva
</script>

<style scoped>
.contact {
  background: var(--background-primary);
  position: relative;
}

.contact::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border-medium), transparent);
}

.contact-content {
  display: flex;
  justify-content: center;
}

.contact-info {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-8);
  max-width: 960px;
  width: 100%;
}

.info-card {
  text-align: center;
}

.info-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
  margin-bottom: var(--space-6);
}

.info-icon {
  width: 48px;
  height: 48px;
  background: var(--gradient-primary);
  border-radius: var(--border-radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: var(--shadow-md);
}

.info-icon svg {
  width: 24px;
  height: 24px;
}

.info-card h3 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin: 0;
  line-height: var(--line-height-snug);
}

.info-card p {
  color: var(--text-secondary);
  margin: var(--space-2) 0;
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-base);
}

.info-card p:first-of-type {
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
}

.info-card p a {
  color: inherit;
  text-decoration: none;
}

.info-card p a:hover {
  color: var(--primary-600);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .contact-info {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }
}
</style>
